import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Link } from 'react-router-dom';

import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

//  Actions - imported
import { setPage, add_To_Recent_History, toggleAuthModal, togglePostModal } from '../actions/navActions';
import { getMatchById } from '../actions/sportsMatchActions';
import { getPostsBySportsMatch, getSportsMatchPhotos, set_ShowBottomSpinner } from '../actions/postActions';
// wrapper layout
import Layout from '../components/layout/Layout';

// Components
import { Button } from '@material-ui/core';
import Spinner from '../components/common/Spinner';
import SportsHeader from '../components/Sports/SportsHeader';
import Post from '../components/Post/Post';
import Image_Block from './MediaPage/Image_Block';
import Empty_Card from './MediaPage/Empty_Card';

// Icons
import CloseIcon from '@material-ui/icons/Close';
import TweetBox from '../components/TweetBox/TweetBox';

// Constant Variables
import TriggerAlerts from '../sideEffects/TriggerAlerts/TriggerAlerts';
import { HorizontalNav } from '../components/common/HorizontalNav';
import FILTER_OPTIONS from '../utils/constant_variables/FILTER_OPTIONS';

const SportsPage = ({ 
    setPage,
    add_To_Recent_History,
    auth, 
    sport: {
        sports_match,
        loading
    },
    nav: { 
        postModal,
        website,
        website_loading
    },
    post,
    getPostsBySportsMatch, 
    getSportsMatchPhotos,
    set_ShowBottomSpinner,
    getMatchById,
    toggleAuthModal,
    togglePostModal,
    match,
    history
}) => {

    // Analytics 
    const [sentMixpanel, setSentMixpanel] = useState(false);

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Check if website is custom url or main website
    const [checked_WebsiteType, setChecked_WebsiteType] = useState(false);

    // Check if user is verified
    const [checkedVerification, setCheckedVerification] = useState(false);

    // Posts
    const [postList, setPostList] = useState([]);
    const [gotPosts, setGotPosts] = useState(false);

    // Scroll direction - for displaying top nav bar
    const [scrollDirection, setScrollDirection] = useState("up");
    const [oldScrollY, setOldScrollY] = useState(window.scrollY);

    // Temporarily disable to load more function to avoid duplicate fetch requests
    const [canLoadMore, setCanLoadMore] = useState(true);

    // Get the "show" and "redirect" parameters from the URL
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const filter = url.searchParams.get("show");
    const intent_filter = url.searchParams.get("intent");
    const hostname = window.location.hostname;

    const SPACE_HEIGHT = 250; // Hieght of className 'no-rides' which is a spacer to make sure user can always scroll down

    // Determine mobile and tablet screen sizes
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;

    useEffect(() => {
        
        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    useEffect(() => {
        // Set the current page
        setPage('sport');
        add_To_Recent_History(url.pathname);  // current url
    }, [])

    // Fetch the sports match data based on the `match.params.id` parameter
    useEffect(() => {
        getMatchById(match.params.id);
    }, [match.params.id])

    // Get sports match posts if sports match exists and on correct page
    useEffect(() => {
        if(!sports_match || website_loading) return;
        setGotPosts(false);
        fetchGroupPosts();

    }, [sports_match, website, filter]);

    // Render posts on screen
    useEffect(() => {

        renderPostList();

    }, [post.posts, canLoadMore]);

    // --- TABS logic ---

    const fetchGroupPosts = () => {

        if(sports_match) {
            if(filter === 'photos') {
                // Load posts with photos if on the profile's 'photos' tab
                getSportsMatchPhotos({ match: sports_match, group_id: website?._id })
                setGotPosts(true);
            } else {
                // Load all posts
                getPostsBySportsMatch({ match: sports_match, group_id: website?._id, filter_tags: intent_filter ? [intent_filter] : null });
                setGotPosts(true);
            }
        }
    }

    // --- END: TABS logic ---

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Handle create Post Modal Toggle
    const handleToggle_PostModal = () => {
        if(auth.user) {
            togglePostModal();
        } else {
            toggleAuthModal('post');
        }
    }

    // Infinite scroll AND handle top nav bar display
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight} = e.target

        const newScrollY = offsetHeight + scrollTop;

        // --- Handle top nav bar display
        if(isMobile) {
            if(oldScrollY < newScrollY){

                // scrolling down - hide top nav
                setScrollDirection("down");
    
                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.remove("active");
                }
                
            } else {
    
                // scrolling up - show top nav
                setScrollDirection("up");
    
                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.add("active");
                }
            }
        }
        // --- END Handle top nav bar display

        // update the scroll position for future comparison
        setOldScrollY(newScrollY)

        // Check if the user has scrolled to the bottom of the content and conditions for loading more posts are met
        if (newScrollY >= scrollHeight - (SPACE_HEIGHT+1) && !post.show_bottom_spinner && !post.no_more_posts && post.posts.length > 0 && canLoadMore) {
            loadMore(post.last_page_doc);
        }
    }

    const loadMore = async (lastPage_doc) => {
        try {
            // Temporarily disable to load more function to avoid duplicate fetch requests
            setCanLoadMore(false);

            // Show spinner
            set_ShowBottomSpinner(true);

            if(filter === 'photos') {
                // Load posts with photos if on the profile's 'photos' tab
                await getSportsMatchPhotos({ match: sports_match, group_id: website?._id, lastPageDoc: lastPage_doc })
            } else {
                // Load all posts
                await getPostsBySportsMatch({ match: sports_match, group_id: website?._id, lastPageDoc: lastPage_doc, filter_tags: intent_filter ? [intent_filter] : null })
            } 
        } catch (error) {
            console.log("ERROR loading more", error);
        } finally {
            // Re-enable the load more capabilty
            setCanLoadMore(true);
        }
    }

    // Check if user is verified. If no redirect to verify page
    if(auth.user && !auth.user.verified && !checkedVerification) {
        window.location.href = '/verify';

        setCheckedVerification(true);
    }

    const renderPostList = async () => {
        setPostList([]);

        if((post.posts === null && loading) || !gotPosts) {
            setPostList([(
                <div className="no-rides">
                    <Spinner />
                </div>
            )])
        }
        else { 
            if(post.posts.length > 0) {
                post.posts.map(post_doc => {
                    if (filter === 'photos') {
                        setPostList(postList => [...postList, (
                            <Image_Block key={post_doc._id} detailPost={post_doc} />
                        )])
                    } else {
                        const renderPostRecursive = (postComments, parentPost) => {
                        
                            const lastComment = postComments[postComments.length - 1]; // Get the last comment
        
                            return (
                                <Fragment>
                                    <Post key={lastComment._id} postDoc={lastComment} parentPost={parentPost} />
        
                                    {/* Recursive call to render comments of comments */}
                                    {lastComment.commentsOfComments && lastComment.commentsOfComments.length > 0 && (
                                        <div className="comments-of-comments">
                                        {renderPostRecursive(lastComment.commentsOfComments, lastComment)}
                                        </div>
                                    )}
                                </Fragment>
                            );
        
                        };
        
                        if(post_doc.commentsOfComments && post_doc.commentsOfComments.length > 0) {
                            setPostList(postList => [...postList, (
                                <div className='post_container'>
                                    <Post key={post_doc._id} postDoc={post_doc} />
        
                                    {renderPostRecursive(post_doc.commentsOfComments, post_doc)}
                                </div>
                            )])
                        } else {
                            setPostList(postList => [...postList, (
                                <Post key={post_doc._id} postDoc={post_doc} />
                            )])
                        }
                    }
                }) 
            } else {
                if (filter === 'photos') {
                    setPostList(postList => [...postList, (
                        <div className="no-rides">
                            <h1>No Photos</h1>
                        </div>
                    )])
                } else {
                    if(intent_filter) {
                        setPostList(postList => [...postList, (
                            <div className="no-rides">
                                <h1 className='placeholder_title'>No posts yet</h1>
                                <p className='placeholder_text'>Couln't find anything under that filter.</p>

                                <Button 
                                    onClick={handleToggle_PostModal}
                                    variant="outlined" 
                                    className="sidebar__tweet minWidth black"
                                >
                                    Create Post
                                </Button>
                            </div>
                        )])
                    } else {
                        setPostList(postList => [...postList, (
                            <div className="no-rides">
                                <h1 className='placeholder_title'>This match doesn't have any posts yet</h1>
                                <p className='placeholder_text'>Be the first to post.</p>
    
                                <Button 
                                    onClick={handleToggle_PostModal}
                                    variant="outlined" 
                                    className="sidebar__tweet minWidth black"
                                >
                                    Create Post
                                </Button>
                            </div>
                        )])
                    }
                }
                
            }
        } 

        setGotPosts(true);
    }

    // Initialize Mixpanel and track Page View
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);
        mixpanel.track("Sports Detail Page View");
    }

    // Check if the code is running in production and Mixpanel event hasn't been sent yet
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {
        
        // Initialize Mixpanel and track the event
        handleMixpanel();

        // Set the flag to indicate that Mixpanel event has been sent
        setSentMixpanel(true);
    }

    // Check if website is custom url or main website (this page is only for custom URLs)
    if(!website_loading && !website && !checked_WebsiteType) {
        // window.location.href = '/home';

        setChecked_WebsiteType(true);
    }

    return (
        <Fragment>
            {/* // -- Trigger Alerts on page load --
            // ----------------------------------
            // after performing an action in another part of the app, user might get redirect to this page.
            // show alerts to user, on their screen, that are pending in localStorage */}

            <TriggerAlerts />

            {/* // -- END: Trigger Alerts on page load -- */}

            <Layout handleScroll={handleScroll} page="sport">

                {loading || auth.loading ? (
                    <Spinner />
                ) : !sports_match ? (
                    <div className="no-post">
                        <p>Hmm...this match doesn’t exist.</p>
                    </div>
                ) : (
                    <Fragment>
                        {/* Render the sports match header */}
                        <SportsHeader history={history} isMobile={isMobile} />
                        {auth.loading ? (
                            <Spinner />
                        ) : auth.user ? (
                            <Fragment>
                                {(filter === 'photos') ? (
                                    <Fragment>
                                        {post.posts.length > 0 ? (
                                            <div style={{width: '100%', height: 'fit-content', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gridAutoRows: 'min-content', borderBottom: '1px solid #ddd'}}>
                                                
                                                {postList}
        
                                                {(!post.no_more_posts && post.posts.length !== 0) && (<Empty_Card last_page_doc={post.last_page_doc} page={"gallery"} loadMore={loadMore} setCanLoadMore={setCanLoadMore} canLoadMore={canLoadMore} />)}
                                            </div>
                                        ) : postList}
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        {/* Filter Options */}
                                        {!intent_filter && !(post.posts?.length > 0) ? null : (
                                            <div style={{margin: '5px 0'}}>
                                                <HorizontalNav>
                                                    {intent_filter && (
                                                        <div
                                                            onClick={() => {
                                                                // Create a copy of the current url object
                                                                const current_url = new URL(url_filter);
                                                                // remove any url variables 
                                                                current_url.searchParams.delete('intent');
                                                                // reload page
                                                                window.location.href = current_url.href;
                                                            }}
                                                            style={{
                                                                // display: 'inline-block',
                                                                // alignSelf: 'stretch',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                height: '33px',
                                                                minWidth: '33px',
                                                                borderRadius: '9999px',
                                                                backgroundColor: '#f3f4f6',
                                                                color: '#4b5563',
                                                                transition: 'background-color 0.15s ease-in-out',
                                                                cursor: 'pointer',
                                                                marginLeft: '5px',
                                                                marginRight: '5px'
                                                            }}
                                                            className='icon_20'
                                                        >
                                                            <CloseIcon />
                                                        </div>
                                                    )}
                                                    {FILTER_OPTIONS.map(item => {
                                                        const isActive = item._id === intent_filter;
                                                        return (
                                                            <div
                                                                onClick={() => {
                                                                    // Create a copy of the current url object
                                                                    const current_url = new URL(url_filter);
                                                                    if(!isActive) {
                                                                        // add this filter's ID to the url variables (automatically handles ? or & formatting)
                                                                        current_url.searchParams.set('intent', item._id?.trim());
                                                                    } else {
                                                                        // add this filter's ID to the url variables (automatically handles ? or & formatting)
                                                                        current_url.searchParams.delete('intent');
                                                                    }
                                                                    // reload page
                                                                    window.location.href = current_url.href;
                                                                }}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    padding: '0 16px',
                                                                    boxSizing: 'border-box',
                                                                    height: '33px',
                                                                    minWidth: 'fit-content',
                                                                    borderRadius: '9999px',
                                                                    backgroundColor: isActive ? '#3b82f6' : '#f3f4f6',
                                                                    color: isActive ? '#ffffff' : '#4b5563',
                                                                    fontSize: '14px',
                                                                    fontWeight: 600,
                                                                    fontFamily: 'sans-serif',
                                                                    transition: 'background-color 0.15s ease-in-out',
                                                                    cursor: 'pointer',
                                                                    marginLeft: '5px'
                                                                }}
                                                            >
                                                                {item.name}
                                                            </div>
                                                        )
                                                    })}
                                                    
                                                </HorizontalNav>
                                            </div>
                                        )}
                                        {/* Render TweetBox component if user is authenticated and postModal is false */}
                                        {(!postModal && !intent_filter) && (
                                            <TweetBox isTablet={isMobile} mobile_redirect={isMobile} />
                                        )}

                                        {postList}

                                        {/* Show a spinner at the bottom if more posts are being loaded */}
                                        {(post.show_bottom_spinner && !post.no_more_posts) && <Spinner />}
                                        
                                        {/* Render a message when there are no more posts to load */}
                                        <div className="no-rides">{(post.no_more_posts && post.posts.length !== 0) && "You've reached the end."}</div>
                                    </Fragment>
                                )}
                            </Fragment>
                        ) : (
                            <Fragment>
                                <div className="no-rides">
                                    <h1 className='placeholder_title'>Your not logged in.</h1>
                                    <p className='placeholder_text'>Log in to view this sports match.</p>

                                    <Button 
                                        onClick={() => toggleAuthModal()}
                                        variant="outlined" 
                                        className="sidebar__tweet minWidth black"
                                    >
                                        Click to Log in
                                    </Button>
                                </div>

                                <div className="no-rides"></div>
                            </Fragment>
                        )}
                    </Fragment>
                )}

            </Layout>
        </Fragment>
    )
}

SportsPage.propTypes = {
    setPage: PropTypes.func.isRequired,
    add_To_Recent_History: PropTypes.func.isRequired,
    getPostsBySportsMatch: PropTypes.func.isRequired,
    getSportsMatchPhotos: PropTypes.func.isRequired,
    set_ShowBottomSpinner: PropTypes.func.isRequired,
    getMatchById: PropTypes.func.isRequired,
    toggleAuthModal: PropTypes.func.isRequired,
    togglePostModal: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    post: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    sport: PropTypes.object.isRequired
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    auth: state.auth,
    post: state.post,
    nav: state.nav,
    sport: state.sport
});

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
    setPage,
    add_To_Recent_History,
    getPostsBySportsMatch,
    getSportsMatchPhotos,
    set_ShowBottomSpinner,
    getMatchById,
    toggleAuthModal,
    togglePostModal
})(SportsPage);
